import React, { useEffect, useMemo, useState } from 'react';
import clsx from 'clsx';
import { AnimatePresence, motion } from 'framer-motion';
import { IconUpArrow } from 'src/components/Icons';
import color_classes from 'src/stylesheets/color_classes.module.scss';
import { Body } from '../Typography';
import styles from './styles.module.scss';

interface BackToTopFABProps {
    containerRef: React.RefObject<HTMLElement>;
    scrollBuffer?: number;
    distanceToTop?: string | number;
    bgColor?: string;
}
function BackToTopFAB({
    containerRef,
    scrollBuffer = 250,
    distanceToTop = '1rem',
    bgColor = 'bgPurple',
}: BackToTopFABProps) {
    const [scrollPosition, setScrollPosition] = useState<number>();

    const handleScrollToTop = () => {
        containerRef.current?.scroll({ top: 0, behavior: 'smooth' });
    };

    useEffect(() => {
        const handleScroll = () => {
            setScrollPosition(containerRef.current?.scrollTop);
        };

        containerRef.current?.addEventListener('scroll', handleScroll);

        return () => {
            containerRef.current?.removeEventListener('scroll', handleScroll);
        };
    }, [containerRef.current]);

    const showScrollToTopFAB = useMemo(() => {
        if (scrollPosition && scrollPosition > scrollBuffer) {
            return true;
        }
        return false;
    }, [scrollPosition]);

    return (
        <AnimatePresence>
            {showScrollToTopFAB && (
                <motion.button
                    onClick={handleScrollToTop}
                    className={styles.button}
                    initial={{ top: 0, opacity: 0 }}
                    animate={{ top: distanceToTop, opacity: 1 }}
                    transition={{ duration: 0.5 }}
                    exit={{ top: 0, opacity: 0 }}
                >
                    <div
                        className={clsx(
                            styles.buttonContent,
                            color_classes[bgColor]
                        )}
                    >
                        <IconUpArrow />{' '}
                        <Body size={12} color="textWhite" weight="bold">
                            BACK TO TOP
                        </Body>
                    </div>
                </motion.button>
            )}
        </AnimatePresence>
    );
}

export default BackToTopFAB;
